import { CONFIG } from '../../core/config';
import { ModelStatusPipe } from '../../shared/pipes/model-status.pipe';
import { ModifiableEntity } from '../editable-entity';
import { ModelStatus } from '../model-status';
import { ViewModel } from '../view-model';
// import { LookupColumn } from '../viewmodel/lookup/LookupColumn';
// import { LookupRow } from  ;
import { VersionedEntity } from '../versioned-entity';
import { NameVersionPipe } from '../../shared/pipes/name-version.pipe';
import { RunnableLookupRow } from '../runnableLookups/runnableLookup-row';
import { RunnableLookupColumn } from '../runnableLookups/runnableLookup-column';
import { RunnableLookupCell } from '../runnableLookups/runnableLookups-cell';
import { ILookup } from '../../viewmodels/runnableLookups/icell';
import { LookupColumnDataType } from '../lookups/lookup-column-data-type';

interface IRunnableLookupRowDictionary {
  [key: string]: RunnableLookupRow;
}
export enum RunnableLookupColumnIdentifier {
  ComponentType= 'COMPONENT_TYPE',
  Description= 'DESCRIPTION'
}

export class RunnableLookup extends ModifiableEntity implements ViewModel, VersionedEntity, ILookup {
  readonly friendlyTypeNameSingular = 'RunnableLookups';
  readonly apiRoute: string = CONFIG.apiRoutes.runnableLookups;

  lookupId: string;
  identifier: string;
  label: string;
  description: string;
  version = 0;
  status: ModelStatus = ModelStatus.Draft;
  clonedFrom: string;
  createdClientSide: boolean;
  get statusText(): string {
    return new ModelStatusPipe().transform(this.status);
  }
  get nameVersionText(): string {
    return new NameVersionPipe().transform(this);
  }

  createdBy: string;
  creationDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;

  get name() { return this.label; }
  set name(value: string) { this.label = value; }

  userDefinedColumns: RunnableLookupColumn[] = [];
  userDefinedRows: IRunnableLookupRowDictionary = {};

  constructor() {
    super();
  }

  json() {
    return this;
  }

  loadFromJson(data: any) {
    super.loadFromJson(data);
    this.lookupId = data.lookupId;
    this.identifier = data.identifier;
    this.label = data.label;
    this.description = data.description;
    this.version = data.version;
    this.createdBy = data.createdBy;
    this.creationDate = data.creationDate;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedDate = data.lastModifiedDate;
    this.status = data.status;
    this.clonedFrom = data.clonedFrom;
    this.createdClientSide = data.createdClientSide;

    if (data.columns) {
      for (const column of data.columns) {
        const newColumn = new RunnableLookupColumn();
        newColumn.loadFromJson(column);
        this.userDefinedColumns.push(newColumn);
      }
    }

    if (data.rows) {
      for (const row of data.rows) {
        const newRow = new RunnableLookupRow();
        newRow.loadFromJson(row);
        this.userDefinedRows[newRow.lookupRowId] = newRow;
      }
    }

    this.userDefinedColumns.forEach(column => {
      if (column.dataType === LookupColumnDataType.Boolean) {
        for (const rowId of Object.keys(this.userDefinedRows)) {
          const row: RunnableLookupRow = this.userDefinedRows[rowId];
          if (row.columns[column.lookupColumnId].value.toLowerCase() === 'false') {
            row.columns[column.lookupColumnId].value = '';
          }
        }
      }
    });

  }

  addUserDefinedColumn(column: RunnableLookupColumn) {
    let i = 0;
    for (const key in this.userDefinedRows) {
      if (this.userDefinedRows.hasOwnProperty(key)) {
        const row = this.userDefinedRows[key];
        row.addColumn(column, <RunnableLookupCell>column.cells[i]);
        i = i + 1;
      }
    }

    this.userDefinedColumns.push(column);
    this.userDefinedColumns = this.userDefinedColumns.slice();
  }

  addUserDefinedRow(row: RunnableLookupRow) {
    this.userDefinedRows[row.lookupRowId] = row;
  }
}
